import { ResourceHelperService } from '../resource-helper.service';

/**
 * A dataservice that provides operations for timebands
 */
export class TimebandService {
  private resource: ng.resource.IResourceClass<ng.resource.IResource<InterACT.Interfaces.Timebands.TimebandResponse | InterACT.Interfaces.Timebands.TimebandsResponse>>;

  constructor($resource: ng.resource.IResourceService, private resourceHelperService: ResourceHelperService) {
    this.resource = $resource('api/timebands/:timebandId', undefined, { update: { method: 'PUT' } });
  }

  /**
   * A method that creates the supplied timeband via a service call
   * @param timeband the timeband to be saved
   */
  public create(timeband: InterACT.Interfaces.Timebands.Timeband) {
    return this.resource.save(timeband).$promise;
  }

  /**
 * A method that updates the supplied timeband via a service call
 * @param timeband the timeband to be updated
 */
  public update(timeband: InterACT.Interfaces.Timebands.Timeband) {
    return (<any>this.resource).update({ timebandId: timeband.id }, timeband).$promise;
  }

  /**
 * A method that deletes the supplied timeband via a service call
   * @param timeband the timeband to be deleted
 */
  public delete(timeband: InterACT.Interfaces.Timebands.Timeband) {
    return this.resource.delete({ timebandId: timeband.id }).$promise;
  }

  /**
   * Function to retrieve a list of timebands
   *
   * @param page The number of the page of data to be retrieved
   * @param perPageCount The number of items per page to be retrieved
   * @param query the query to execute against the dataset
   * @returns A http promise
   */
  public getList(page: number, perPageCount: number, query?: string) {
    const options = this.resourceHelperService.buildRequestOptions(page, perPageCount, query);
    return <ng.IPromise<InterACT.Interfaces.Timebands.TimebandsResponse>>this.resource.get(options).$promise;
  }
}
